import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-space-y-4" }
const _hoisted_2 = { class: "tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-3" }
const _hoisted_3 = { class: "tw-text-lg tw-font-semibold tw-tracking-tight tw-text-slate-900" }
const _hoisted_4 = { class: "tw-text-sm tw-text-slate-600" }
const _hoisted_5 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4 tw-text-sm tw-text-slate-700" }
const _hoisted_6 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4" }
const _hoisted_7 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GmapPolyline = _resolveComponent("GmapPolyline")!
  const _component_GmapMarker = _resolveComponent("GmapMarker")!
  const _component_GmapMap = _resolveComponent("GmapMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, "Load " + _toDisplayString(_ctx.load.loadDocumentId), 1),
      _createElementVNode("div", _hoisted_4, "Status: " + _toDisplayString(_ctx.load.status), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, "Created: " + _toDisplayString(_ctx.formatDatetime(_ctx.load.createdAt)), 1),
      _createElementVNode("div", null, "Last updated: " + _toDisplayString((_ctx.load.lastUpdatedAt && _ctx.formatDatetime(_ctx.load.lastUpdatedAt)) || '---'), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!!_ctx.load.gpsPath)
        ? (_openBlock(), _createBlock(_component_GmapMap, {
            key: 0,
            center: _ctx.load.gpsPath.path[0],
            zoom: 6,
            "map-type-id": "terrain",
            class: "map-responsive"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GmapPolyline, {
                path: _ctx.load.gpsPath.path
              }, null, 8, ["path"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.load.gpsPath.path, (point, pointIdx) => {
                return (_openBlock(), _createBlock(_component_GmapMarker, {
                  key: pointIdx,
                  position: point,
                  clickable: true,
                  draggable: true
                }, null, 8, ["position"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["center"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, " (no GPS trip data for this load yet) "))
    ])
  ]))
}